// Lightweight Google Analytics 4 wrapper.
// GA only loads on the production host, so preview/dev/testing traffic never pollutes Linda's property.
// Off-production, events are recorded on window.__bbEvents so QA can verify they fire (and fire once).

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const PROD_HOSTS = ["backyardbuddy.app", "www.backyardbuddy.app"];
const INTERNAL_KEY = "bb_internal_traffic";
let initialized = false;

export const IS_PROD_HOST = typeof window !== "undefined" && PROD_HOSTS.includes(window.location.hostname);
export const ANALYTICS_ENABLED = Boolean(MEASUREMENT_ID) && IS_PROD_HOST;

function isInternal() {
  try { return localStorage.getItem(INTERNAL_KEY) === "1"; } catch { return false; }
}

function record(name, params) {
  if (typeof window === "undefined") return;
  window.__bbEvents = window.__bbEvents || [];
  const last = window.__bbEvents[window.__bbEvents.length - 1];
  // Dev-only React.StrictMode re-runs mount effects synchronously; collapse that echo so the log reflects prod behavior.
  if (last && last.name === name && Date.now() - last.at < 50 && JSON.stringify(last.params) === JSON.stringify(params)) return;
  window.__bbEvents.push({ name, params, at: Date.now() });
}

export function initGA() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  if (!ANALYTICS_ENABLED) return;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // Devices where an admin has signed in are tagged internal so GA4's "Internal traffic" filter can exclude them.
  if (isInternal()) window.gtag("set", { traffic_type: "internal" });
  // Disable automatic page_view; we'll send them on route change so SPA navigations are captured.
  window.gtag("config", MEASUREMENT_ID, { send_page_view: false });
}

// Called once an admin account is detected: every later hit from this browser carries traffic_type=internal.
export function markInternalTraffic() {
  try { localStorage.setItem(INTERNAL_KEY, "1"); } catch { /* storage unavailable */ }
  if (ANALYTICS_ENABLED && window.gtag) window.gtag("set", { traffic_type: "internal" });
}

export function trackPageView(path, title) {
  const params = { page_path: path, page_location: window.location.origin + path, page_title: title || document.title };
  if (!ANALYTICS_ENABLED) { record("page_view", params); return; }
  if (window.gtag) window.gtag("event", "page_view", params);
}

export function trackEvent(name, params = {}) {
  if (!ANALYTICS_ENABLED) { record(name, params); return; }
  if (window.gtag) window.gtag("event", name, params);
}
